import { useEffect, useState } from "react";
import axios from "axios";
import "./studentReferral.css";

const EmailCouponTransactions = ({ email }) => {
  const [data, setData] = useState(null);
  const [maxDiscount, setMaxDiscount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!email) {
      setErr("No logged-in email found.");
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const [txRes, discRes] = await Promise.all([
          axios.get(
            `https://onlineexam.ssccglpinnacle.com/email-coupon-transactions?email=${encodeURIComponent(
              email
            )}`
          ),
          axios.get("https://onlineexam.ssccglpinnacle.com/student-discounts"),
        ]);

        const payload = txRes?.data;
        if (
          !payload ||
          (!payload.results && !Array.isArray(payload?.results))
        ) {
          throw new Error("Malformed response");
        }
        setData({
          email: payload.email ?? email,
          count: payload.count ?? payload.results?.length ?? 0,
          results: payload.results ?? [],
        });

        const discountsArr = Array.isArray(discRes?.data) ? discRes.data : [];
        const ts = discountsArr.find(
          (d) =>
            String(d.category || "")
              .toLowerCase()
              .trim() === "test series"
        );
        setMaxDiscount(Number(ts?.maxDiscount) || 0);
      } catch (e1) {
        console.log("Error fetching data:", e1);
        setErr("Server error. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [email]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };

  const formatINR = (n) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }).format(Number(n) || 0);

  if (loading) return <p>Loading...</p>;
  if (err) return <p>{err}</p>;
  if (!data) return <p>No data found.</p>;

  return (
    <div className="emailTx">
      <h2 style={{ textAlign: "center" }}>Your Shared Details</h2>
      <p className="email-info">
        <strong>Email :</strong> {data.email}
      </p>
      <p className="total-info">
        <strong>Total Number of Shares :</strong> {data.count} Times
      </p>

      {Array.isArray(data.results) && data.results.length > 0 ? (
        <div
          style={{ overflowX: "auto", maxWidth: "100%", margin: "20px auto" }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
              textAlign: "center",
              border: "1px solid #ddd",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              borderRadius: "8px",
              whiteSpace: "nowrap",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f4f6f8", color: "#333" }}>
                {[
                  "Coupon Code",
                  "Title",
                  "Shared Date",
                  // "Status",
                  // "Referred Email",
                  // "Transaction Time",
                  // "Commission",
                ].map((h) => (
                  <th
                    key={h}
                    style={{ padding: "12px", border: "1px solid #ddd" }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {data.results.map((item, idx) => {
                const isClicked =
                  item.transaction !== null && item.transaction !== undefined;
                const statusText = isClicked
                  ? item.transaction.status
                  : "Not-Clicked";
                const isSuccess =
                  isClicked &&
                  String(item.transaction.status).toUpperCase() === "SUCCESS";
                const transactionDate = isClicked
                  ? new Date(item.transaction.createdAt).toLocaleString()
                  : "-";
                const customerEmail = isClicked
                  ? item.transaction.customer_email
                  : "-";

                const commission = isSuccess
                  ? (item.cartItems || []).reduce(
                      (sum, ci) =>
                        sum + (maxDiscount / 100) * (Number(ci.price) || 0),
                      0
                    )
                  : 0;

                return (
                  <tr
                    key={idx}
                    style={{
                      backgroundColor: idx % 2 === 0 ? "#fff" : "#fafafa",
                      transition: "background 0.3s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f1f7ff")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        idx % 2 === 0 ? "#fff" : "#fafafa")
                    }
                  >
                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                      {item.stdcpncde}
                    </td>

                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                      <div
                        style={{
                          display: "inline-flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >                  
                        {(item.cartItems || []).map((ci, i) => (
                          <span
                            key={ci.id ?? `${ci.title}-${i}`}
                            style={{
                              display: "inline-block",
                              padding: "6px 10px",
                              border: "1px solid #ddd",
                              borderRadius: "999px",
                              background: "#f4f6f8",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {ci.title} - ₹{ci.price} ({ci.totalTests} tests)
                          </span>
                        ))}
                      </div>
                    </td>

                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                      {formatDate(item.shareCreatedAt)}
                    </td>

                    {/* <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 10px",
                          borderRadius: "999px",
                          border: "1px solid #ddd",
                          background:
                            String(statusText).toUpperCase() === "SUCCESS"
                              ? "#e7f7ee"
                              : "#f1f1f1",
                          color:
                            String(statusText).toUpperCase() === "SUCCESS"
                              ? "#137a36"
                              : "#555",
                          fontWeight: 600,
                        }}
                      >
                        {statusText}
                      </span>
                    </td>

                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                      {customerEmail}
                    </td>
                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                      {isClicked
                        ? new Date(
                            item.transaction.createdAt
                          ).toLocaleDateString("en-GB")
                        : "-"}
                    </td>

                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                      {isSuccess ? formatINR(commission) : "-"}
                    </td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p>
          No transactions for <strong>{email}</strong>.
        </p>
      )}
    </div>
  );
};

export default EmailCouponTransactions;
